export enum BUTTON_VARIANT {
    CONTAINED = 'contained',
    OUTLINED = 'outlined',
    STANDARD = 'standard',
}

export enum BUTTON_COLOR {
    WARNING = 'warning',
    PRIMARY = 'primary',
    SUCCESS = 'success',
}

export enum BUTTON_TYPE {
    SUBMIT = 'submit',
    RESET = 'reset',
    BUTTON = 'button',
}
